
<fieldset [disabled]="isWorkflowOnSubscriber">
  <div class="row d-flex align-items-center">
    <div class="col-sm-6">
      <h2 class="text-primary mb-0">
        {{cardConfiguration.title}}
      </h2>
    </div>
    <div class="col-sm-6 text-end">
      <button (click)="onExpandNewEntry()" type="button" [ngClass]="!expandNewEntry ? '' : 'disabled'" aria-label="Nova entrada" class="btn btn-link disable-on-fieldset"><span class="icon-add"></span> <span>{{'CardEffectivityMap.EffectivityTable.AddItem' | translate}}</span></button>
    </div>
  </div>

  <!--New table entry inputs-->
  <div *ngIf="expandNewEntry" class="shadow ml-5 mr-5 p-4 mb-4 mt-5">
    <button type="button" class="close" aria-label="Fechar" (click)="onCloseNewEntry()">
      <span aria-hidden="true" class="icon-close text-primary"></span>
    </button>
    <h3 class="text-primary">{{'CardEffectivityMap.EffectivityTable.AddItem' | translate}}</h3>
    <effectivity-table-edit [itemList]="cardData.effectivityList" (listChanged)="onEffectivityListChanged($event)" [preFilledItem]="preFilledItem"></effectivity-table-edit>
  </div>

 

  <!-- Booleans in VM are being considered string @ runtime, boolean validationsn need to be changed once they are the proper type @ runtime-->
  <effectivity-timeline [effectivityList]="cardData.effectivityList" [listChangeSubject]="listChangeSubject" (timeLineClick)="onTimeLineClicked($event)" [effectivityMapMinDate]="cardData.effectivityMapMinDate"></effectivity-timeline>


  <div class="row">
    <div class="col-sm-6 mt-5">
      <h3 class="text-primary" *ngIf="filterStartDate && filterEndDate">{{'CardEffectivityMap.Period' | translate}} {{filterStartDate | date : 'yyyy'}} - {{filterEndDate | date  : 'yyyy'}}</h3>
    </div>
  </div>



  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">{{'CardEffectivityMap.EffectivityTable.Entity' | translate}}</th>
        <th scope="col" style="min-width: 125px">{{'CardEffectivityMap.EffectivityTable.Start' | translate}}</th>
        <th scope="col" style="min-width: 125px">{{'CardEffectivityMap.EffectivityTable.End' | translate}}</th>
        <th scope="col">{{'CardEffectivityMap.EffectivityTable.ScheduleType' | translate}}</th>
        <th scope="col">Efetuou descontos</th>
        <th scope="col">Aumento de tempo</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <ng-container *ngFor="let tableItem of cardData.effectivityList; let i = index">
        <ng-container *ngIf="(!filterStartDate || !filterEndDate)  || (tableItem.startDate >= filterStartDate && tableItem.startDate <= filterEndDate)">
          <tr   [ngClass]="expandedRowIndex == i ? 'text-primary table-active-top-border' : 'enabled'" (click)="expandRow(i)">
            <td *ngIf="tableItem.entity === 'Outra' && tableItem.otherEntity">{{tableItem.otherEntity}}</td>
            <!--<td *ngIf="tableItem.entity === 'Outra' && tableItem.otherEntity && isDate(tableItem.otherEntity)">{{tableItem.otherEntity | date : 'yyyy-MM-dd'}}</td>-->
            <td *ngIf="tableItem.entity !== 'Outra' || !tableItem.otherEntity">{{tableItem.entity}}</td>
            <td class="fitwidth">{{tableItem.startDate | date : 'yyyy-MM-dd'}}</td>
            <td class="fitwidth">{{tableItem.endDate| date : 'yyyy-MM-dd'}}</td>
            <td>{{tableItem.scheduleTypeCode | commonData : scheduleTypes : 'code' : 'desc'}}</td>
            <td [innerHtml]="translateBoolean(tableItem.hasDiscounts)"></td>
            <td>{{translateBoolean(tableItem.timeIncrease)}}</td>
            <td class="buttons-edit" [ngClass]="expandedRowIndex == enabled ? 'active' : 'inactive'">
              <button type="button" class="btn-icon" aria-label="Editar" [attr.aria-expanded]="expandedRowIndex == i" aria-controls="collapseBasic">
                <span class="p-1" [ngClass]="expandedRowIndex == i ? 'text-primary  icon-close' :  disableTableRemoveIcons ? 'text-primary icon-more' : 'text-primary icon-edit'"></span>
              </button>
              <button *ngIf="!disableTableRemoveIcons && ((tableItem.origin!=='AC' && isVersion2()) || !isVersion2())" type="button" class="btn-icon" aria-label="Apagar" (click)="removeEffectivity(i,$event)">
                <span class="icon-trash p-1" [ngClass]="expandedRowIndex == i ? 'text-primary' : 'text-primary'"></span>
              </button>
            </td>
          </tr>
          <tr *ngIf="expandedRowIndex == i" [collapse]="expandedRowIndex != i" [isAnimated]="false">
            <td class="p-0" colspan="7" id="collapseBasic">
              <div class="ml-5 mr-5 p-4">
                <effectivity-table-edit [itemList]="cardData.effectivityList" [editIndex]="i" (listChanged)="onEffectivityListChanged($event)"></effectivity-table-edit>
              </div>
            </td>
          </tr>
        </ng-container>
      </ng-container>
    </tbody>
  </table>
</fieldset>
<!--<pre>{{cardData | json}}</pre>-->
